import { Panel, PanelGroup } from '@southfields-digital/mxmz-react-ui';

import QuickControl from 'src/components/QuickControl/QuickControl';

function LayoutQuickControl() {
  return (
    <div className="max-w-2xl w-full h-full mx-auto [&>div]:bg-elevated-1">
      <PanelGroup direction="vertical">
        <Panel defaultSize={42}>
          {/* @TO-DO: check if we can remove this key */}
          <QuickControl key={Math.random()} />
        </Panel>
      </PanelGroup>
    </div>
  );
}

export default LayoutQuickControl;
